import React, { useState } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import LoginButton from './components/LoginButton';
import { oktaEndpoints } from './config/oktaConfig';

const AccountSelector = ({ accounts, onSelect }) => {
  const [selectedAccount, setSelectedAccount] = useState('');

  const handleChange = (e) => {
    const accountId = e.target.value;
    setSelectedAccount(accountId);
    if (onSelect) {
      onSelect(accountId);
    }
  };

  return (
    <div>
      <label htmlFor="account-select">Select Account: </label>
      <select id="account-select" value={selectedAccount} onChange={handleChange}>
        <option value="" disabled>Select an account</option>
        {accounts.map((account) => (
          <option key={account.id} value={account.id}>{account.name}</option>
        ))}
      </select>
    </div>
  );
};

const WidgetApp = () => {
  const { authState, oktaAuth } = useOktaAuth();
  
  const accounts = [
    { id: '1', name: 'Account 1' },
    { id: '2', name: 'Account 2' },
    { id: '3', name: 'Account 3' },
  ];

  const handleAccountSelect = async (accountId) => {
    if (!authState?.isAuthenticated) {
      console.error('User not authenticated');
      return;
    }

    // Get user info from Okta token
    const userEmail = authState.idToken?.claims?.email || "asoldev793@sharklasers.com";
    const userName = authState.idToken?.claims?.name || "User";

    const body = {
      "EmailId": userEmail,
      "claims": [
        { "Name": "IT:OrgId", "Value": "50488085" },
        { "Name": "IT:CustAccountRoleId", "Value": "100000700736593" },
        { "Name": "IT:PersonId", "Value": "14960112" },
        { "Name": "IT:PersonGtc", "Value": "Compliant" },
        { "Name": "IT:PersonStatus", "Value": "Current" },
        { "Name": "IT:IsEmployee", "Value": "False" },
        { "Name": "IT:CustomerId", "Value": "50488085" },
        { "Name": "SelectedAccountId", "Value": accountId }
      ]
    };

    try {
      const response = await fetch(oktaEndpoints.workflowUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body)
      });
      
      const result = await response.json();
      console.log("API response:", result);
      
      // Redirect to Citrix after successful API call
      if (response.ok) {
        console.log("API call successful, redirecting to Citrix...");
        window.location.href = oktaEndpoints.citrixRedirectUrl;
      } else {
        console.error("API call failed with status:", response.status, result);
      }
    } catch (error) {
      console.error("API error:", error);
    }
  };

  if (!authState) {
    return <div>Loading authentication state...</div>;
  }

  return (
    <div style={{ maxWidth: '600px', margin: '20px auto', padding: '20px' }}>
      <h3>Account Selector Widget</h3>
      
      <LoginButton />
      
      {authState.isAuthenticated ? (
        <div>
          <AccountSelector accounts={accounts} onSelect={handleAccountSelect} />
        </div>
      ) : (
        <div style={{ 
          padding: '20px', 
          textAlign: 'center', 
          backgroundColor: '#f8f9fa', 
          borderRadius: '8px' 
        }}>
          Please log in to access account selection
        </div>
      )}
    </div>
  );
};

export default WidgetApp;
